import React from 'react';
import PropTypes from 'prop-types';

const MenuButton = ({ onClick, open }) => {
  const s = require('./menu.module.scss');
  return (
    <div
      className={`${s.MenuButton} ${open && s.opened}`}
      onClick={(e) => {
        if (typeof onClick === 'function') onClick(e);
      }}
    >
      <div className={s.MenuBox}>
        <div className={s.line} />
      </div>
    </div>
  );
};

MenuButton.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool,
};

export default MenuButton;
